module.exports = __webpack_public_path__ + "img/phone.e60b69eb.png";